{
  "properties.title": "Woningen",
  "properties.count": "{count, plural, one {# woning} other {# woningen}}",
  "properties.new": "Nieuwe woning",
  "properties.search_label": "Woningen zoeken",
  "properties.search_placeholder": "Referentie, plaats of titel",
  "properties.kind": "Soort",
  "properties.any_kind": "Alle soorten",
  "properties.any_status": "Alle statussen",
  "properties.attention": "Aandacht",
  "properties.attention_any": "Alles",
  "properties.attention_not_ready": "Nog niet publiceerbaar",
  "properties.attention_rights": "Websiterecht ontbreekt",
  "properties.attention_stale": "Verouderde vertalingen",
  "properties.sort": "Sorteren",
  "properties.sort_updated": "Laatst gewijzigd",
  "properties.sort_reference": "Referentie",
  "properties.sort_price_desc": "Prijs, hoog naar laag",
  "properties.sort_price_asc": "Prijs, laag naar hoog",
  "properties.clear_filters": "Filters wissen",
  "properties.col_photo": "Foto",
  "properties.col_property": "Woning",
  "properties.col_price": "Prijs",
  "properties.col_status": "Status",
  "properties.col_facts": "Kenmerken",
  "properties.col_attention": "Aandacht",
  "properties.col_updated": "Gewijzigd",
  "properties.untitled": "Nog zonder titel",
  "properties.on_request": "Op aanvraag",
  "properties.beds": "{count, plural, =0 {Geen slaapkamers} one {# slpk} other {# slpk}}",
  "properties.baths": "{count, plural, one {# badk} other {# badk}}",
  "properties.signal_rights": "Geen geldig websiterecht: wordt niet gepubliceerd",
  "properties.signal_photos": "Nog geen foto's",
  "properties.signal_stale": "{count, plural, one {# vertaling verouderd} other {# vertalingen verouderd}}",
  "properties.signal_pending": "{count, plural, one {# vertaling wacht op review} other {# vertalingen wachten op review}}",
  "properties.signal_none": "Alles in orde",
  "properties.empty_title": "Nog geen woningen",
  "properties.empty_body": "Maak een woning aan of importeer je aanbod via Imports.",
  "properties.empty_filtered_title": "Geen woningen met deze filters",
  "properties.empty_filtered_body": "Pas de filters aan of wis ze om alles te zien.",
  "properties.bulk_label": "Bulkacties",
  "properties.bulk_actions": "Wijzigen",
  "properties.bulk_set_status": "Status zetten op",
  "properties.bulk_set_editorial": "Redactiestatus",
  "properties.bulk_other": "Overig",
  "properties.bulk_price": "Prijs aanpassen met een percentage",
  "properties.bulk_price_title": "{count, plural, one {Prijs van # woning aanpassen} other {Prijzen van # woningen aanpassen}}",
  "properties.bulk_price_body": "Elke vraagprijs gaat met hetzelfde percentage omhoog of omlaag. Woningen met prijs op aanvraag blijven ongewijzigd.",
  "properties.bulk_price_percent": "Percentage",
  "properties.bulk_price_hint": "Tussen −50 en 50. Gebruik een min voor een verlaging.",
  "properties.bulk_price_apply": "Prijzen aanpassen",
  "properties.bulk_done": "{ok, plural, =0 {Niets gewijzigd} one {# woning bijgewerkt} other {# woningen bijgewerkt}}",
  "properties.bulk_failed": "{failed, plural, one {# woning niet gewijzigd; open die voor de reden.} other {# woningen niet gewijzigd; open ze voor de reden.}}",
  "properties.new_title": "Nieuwe woning",
  "properties.new_body": "Begin met de basis. Foto's, teksten en rechten vul je daarna aan in het dossier.",
  "properties.reference": "Referentie",
  "properties.reference_hint": "Uniek binnen je organisatie, bijvoorbeeld TB-4210.",
  "properties.offer_kind": "Aanbod",
  "properties.price": "Vraagprijs",
  "properties.price_hint": "Leeg laten voor prijs op aanvraag.",
  "properties.locality": "Plaats",
  "properties.new_submit": "Woning aanmaken",
  "properties.created": "{reference} aangemaakt als concept",
  "editor.add_grant": "Recht vastleggen",
  "editor.add_link": "Link toevoegen",
  "editor.add_lock": "Veld vergrendelen",
  "editor.advice": "Advies",
  "editor.archive": "Archiveren",
  "editor.area": "Gebied",
  "editor.area_hint": "Bepaalt op welke gebiedspagina de woning verschijnt.",
  "editor.area_none": "Geen gebied",
  "editor.basis": "Grondslag",
  "editor.bathrooms": "Badkamers",
  "editor.bedrooms": "Slaapkamers",
  "editor.blocking": "Blokkeert publicatie",
  "editor.blocking_count": "{count, plural, one {# punt blokkeert publicatie} other {# punten blokkeren publicatie}}",
  "editor.built": "Bebouwd",
  "editor.cadastral_ref": "Kadastrale referentie",
  "editor.changed": "Gewijzigd {when}",
  "editor.channel": "Kanaal",
  "editor.channel_hint": "Bijvoorbeeld idealista of kyero. Leeg betekent alle portalen.",
  "editor.chars": "{count} van {max} tekens",
  "editor.choose_files": "Bestanden kiezen",
  "editor.commission_note": "Afspraken over courtage",
  "editor.community_fee": "Gemeenschapskosten per jaar",
  "editor.conflict_title": "Intussen gewijzigd door iemand anders",
  "editor.conflict_body": "Je werkte op versie {yours}; de woning staat nu op versie {current}. Kies wat er met jouw wijzigingen gebeurt.",
  "editor.conflict_later": "Nog niets doen",
  "editor.conflict_reload": "Mijn wijzigingen weggooien",
  "editor.conflict_overwrite": "{count, plural, one {Mijn wijziging toch opslaan} other {Mijn # wijzigingen toch opslaan}}",
  "editor.conflict_yours": "Jouw wijzigingen: {fields}",
  "editor.cover": "Hoofdfoto",
  "editor.cover_set": "Hoofdfoto gekozen",
  "editor.current": "huidig",
  "editor.description": "Omschrijving",
  "editor.description_hint": "Feiten zoals prijs en oppervlakte worden bij vertalingen automatisch gecontroleerd.",
  "editor.discard": "Wijzigingen weggooien",
  "editor.duplicate": "Dupliceren",
  "editor.duplicate_title": "{reference} dupliceren",
  "editor.duplicate_body": "Kopieert gegevens, prijs en teksten naar een nieuw concept. Foto's, rechten en vertalingen gaan niet mee.",
  "editor.duplicate_submit": "Kopie maken",
  "editor.duplicated": "{reference} gemaakt als kopie",
  "editor.edit_rights": "Beeldrechten wijzigen",
  "editor.energy_consumption": "Verbruik",
  "editor.energy_rating": "Energielabel",
  "editor.energy_status": "Energiecertificaat",
  "editor.evidence": "Bewijs of verwijzing",
  "editor.evidence_hint": "Bijvoorbeeld het nummer van de opdracht of de datum van de mail.",
  "editor.fix": "Oplossen",
  "editor.floor": "Verdieping",
  "editor.floorplan": "Plattegrond",
  "editor.generated": "Gegenereerd",
  "editor.grant_added": "Recht vastgelegd",
  "editor.grant_body": "Zonder geldig recht voor de website wordt de woning niet gepubliceerd.",
  "editor.grant_submit": "Recht vastleggen",
  "editor.history": "Versies",
  "editor.key_instructions": "Sleutels en toegang",
  "editor.last_seen": "laatst gezien {when}",
  "editor.leave_title": "Wijzigingen niet opgeslagen",
  "editor.leave_body": "{count, plural, one {Je hebt # wijziging die nog niet is opgeslagen.} other {Je hebt # wijzigingen die nog niet zijn opgeslagen.}}",
  "editor.leave_confirm": "Weggaan zonder opslaan",
  "editor.leave_stay": "Blijven",
  "editor.link_added": "Link toegevoegd",
  "editor.link_url": "Adres",
  "editor.link_url_hint": "Alleen https-links.",
  "editor.links_title": "Video en rondleiding",
  "editor.live_revision": "Live in revisie {revision}, {when}",
  "editor.loc_missing": "Ontbreekt",
  "editor.locality": "Plaats",
  "editor.lock_body": "Een vergrendelde groep wordt bij imports niet overschreven.",
  "editor.lock_reason_hint": "Bijvoorbeeld: prijs afgesproken met eigenaar, feed loopt achter.",
  "editor.lock_submit": "Vergrendelen",
  "editor.lock_which": "Welke gegevens",
  "editor.locked": "Vergrendeld voor imports",
  "editor.locks": "Vergrendeld voor imports",
  "editor.locks_hint": "Handmatige correcties blijven staan, ook als een feed iets anders meldt.",
  "editor.make_cover": "Als hoofdfoto gebruiken",
  "editor.mark_ready": "Markeren als klaar",
  "editor.media_actions": "Acties voor dit beeld",
  "editor.media_removed": "Beeld verwijderd",
  "editor.media_reordered": "Volgorde opgeslagen",
  "editor.media_type": "Soort",
  "editor.meta_description": "Zoekmachinetekst",
  "editor.meta_hint": "Korte samenvatting voor Google. Leeg laten gebruikt de eerste zin van de omschrijving.",
  "editor.missing_since": "ontbreekt in feed sinds {when}",
  "editor.municipality": "Gemeente",
  "editor.never_published": "Nog niet gepubliceerd",
  "editor.new_reference": "Nieuwe referentie",
  "editor.no_field_changes": "Geen veldwijzigingen",
  "editor.no_files": "Nog geen bestanden gekozen. Je kunt ze ook op de fotolijst slepen.",
  "editor.no_history": "Nog geen versies",
  "editor.no_links": "Geen video of virtuele rondleiding.",
  "editor.no_locks": "Niets vergrendeld.",
  "editor.no_offer_title": "Geen actief aanbod",
  "editor.no_offer_body": "Deze woning heeft geen actieve verkoop of verhuur. Voeg die toe via een import of maak de woning opnieuw aan.",
  "editor.no_photos_title": "Nog geen foto's",
  "editor.no_photos_body": "Sleep foto's hierheen of kies bestanden. Minimaal 800 × 500 pixels.",
  "editor.no_portals_title": "Niet op portalen",
  "editor.no_portals_body": "Zodra een portaalfeed deze woning bevat, zie je hier de leverstatus.",
  "editor.no_rights_title": "Geen rechten vastgelegd",
  "editor.no_rights_body": "Leg vast op welke grond je deze woning mag tonen op de website en portalen.",
  "editor.no_sources": "Handmatig ingevoerd; geen externe bron gekoppeld.",
  "editor.no_translations": "Nog geen vertalingen.",
  "editor.not_publishable": "{count, plural, one {Nog niet publiceerbaar: # punt} other {Nog niet publiceerbaar: # punten}}",
  "editor.not_publishable_body": "Een publicatie slaat deze woning over tot de rode punten zijn opgelost.",
  "editor.open_ended": "onbepaald",
  "editor.open_queue": "Naar de vertaalwachtrij",
  "editor.open_site": "Website openen",
  "editor.orientation": "Ligging",
  "editor.ownership": "Soort aanbod",
  "editor.period": "Periode",
  "editor.photo": "Foto",
  "editor.photos_hint": "Sleep om de volgorde te wijzigen. De eerste foto's verschijnen bovenaan op de website.",
  "editor.photos_label": "Foto's en plattegronden",
  "editor.photos_title": "{count, plural, =0 {Foto's} one {# beeld} other {# beelden}}",
  "editor.plot": "Perceel",
  "editor.portals": "Portalen",
  "editor.postal_code": "Postcode",
  "editor.precision": "Locatie tonen als",
  "editor.precision_hint": "Het exacte adres staat nooit op de website.",
  "editor.price_on_request": "Prijs op aanvraag",
  "editor.private_note": "Alleen intern zichtbaar. Deze gegevens gaan nooit naar de website of portalen.",
  "editor.property_tax": "Onroerendgoedbelasting (IBI) per jaar",
  "editor.province": "Provincie",
  "editor.publishable": "Klaar om te publiceren",
  "editor.publishable_body": "Alle verplichte gegevens, foto's en rechten zijn aanwezig.",
  "editor.publishable_with_advice": "Er zijn nog adviezen, maar niets blokkeert.",
  "editor.readiness": "Publicatiecontrole",
  "editor.reason": "Reden",
  "editor.reason_hint": "Minimaal 3 tekens; komt in de historie.",
  "editor.remove_title": "Beeld verwijderen?",
  "editor.remove_body": "Het beeld verdwijnt bij de volgende publicatie van de website.",
  "editor.remove_cover_body": "Dit is de hoofdfoto. Kies daarna een nieuwe hoofdfoto, anders kan de woning niet gepubliceerd worden.",
  "editor.remove_confirm": "Beeld verwijderen",
  "editor.remove_media": "Verwijderen",
  "editor.rent": "Huurprijs",
  "editor.restore": "Terugzetten",
  "editor.restore_title": "Versie {version} terugzetten?",
  "editor.restore_body": "De gegevens van die versie worden een nieuwe versie. Niets gaat verloren.",
  "editor.restore_dirty": "Je niet-opgeslagen wijzigingen gaan verloren. De gegevens van die versie worden een nieuwe versie.",
  "editor.restore_confirm": "Versie {version} terugzetten",
  "editor.restored": "Versie {version} teruggezet",
  "editor.revoke": "Intrekken",
  "editor.revoke_title": "Recht intrekken?",
  "editor.revoke_body": "Bij de volgende portaalfeed wordt de woning daar teruggetrokken.",
  "editor.revoke_website_title": "Websiterecht intrekken?",
  "editor.revoke_website_body": "De woning verdwijnt direct van de live website: het adres geeft daarna een melding dat de woning niet meer wordt aangeboden.",
  "editor.revoke_website_confirm": "Direct van de website halen",
  "editor.revoked": "Recht ingetrokken",
  "editor.revoked_website": "Ingetrokken en direct van de website gehaald",
  "editor.rights_body": "Leg vast waar dit beeld vandaan komt en waar je het mag gebruiken.",
  "editor.rights_channels": "Mag gebruikt worden op",
  "editor.rights_channels_hint": "Alleen gekozen kanalen krijgen dit beeld.",
  "editor.rights_credit": "Fotograaf of bron",
  "editor.rights_generated_note": "Dit is een gegenereerd demobeeld. De herkomst staat vast en is niet te wijzigen.",
  "editor.rights_grants": "Rechten",
  "editor.rights_license": "Licentie",
  "editor.rights_license_hint": "Vermeld het licentienummer of de link naar de voorwaarden.",
  "editor.rights_saved": "Beeldrechten opgeslagen",
  "editor.rights_source": "Herkomst",
  "editor.rights_title": "Beeldrechten",
  "editor.rights_unknown": "Herkomst onbekend",
  "editor.save_bar": "Opslaan",
  "editor.saved": "Opgeslagen als versie {version}",
  "editor.saved_stale": "{count, plural, one {# vertaling is nu verouderd en wacht op een update.} other {# vertalingen zijn nu verouderd en wachten op een update.}}",
  "editor.scope": "Waarvoor",
  "editor.section_basics": "Basisgegevens",
  "editor.section_costs": "Vaste lasten",
  "editor.section_energy": "Energie en vergunningen",
  "editor.section_features": "Kenmerken en uitzicht",
  "editor.section_location": "Locatie",
  "editor.section_offer": "Aanbod",
  "editor.section_private": "Intern",
  "editor.sold_note": "Verkochte en verhuurde woningen blijven op de website staan als referentie, zonder aanvraagformulier.",
  "editor.source_agency": "Bronkantoor",
  "editor.source_texts": "Brontekst ({locale})",
  "editor.sources": "Bronnen",
  "editor.street_address": "Adres",
  "editor.tab_facts": "Gegevens",
  "editor.tab_history": "Versies",
  "editor.tab_media": "Foto's",
  "editor.tab_offer": "Prijs en status",
  "editor.tab_publish": "Publicatie",
  "editor.tab_rights": "Rechten en bronnen",
  "editor.tab_texts": "Teksten",
  "editor.tabs": "Onderdelen van het dossier",
  "editor.terrace": "Terras",
  "editor.texts_stale_warning": "Na opslaan worden bestaande vertalingen van deze tekst als verouderd gemarkeerd.",
  "editor.title": "Titel",
  "editor.tourist_license": "Toeristische vergunning",
  "editor.translations": "Vertalingen",
  "editor.unlock": "Ontgrendelen",
  "editor.unlocked": "Ontgrendeld",
  "editor.unsaved": "{count, plural, one {# wijziging niet opgeslagen} other {# wijzigingen niet opgeslagen}}",
  "editor.upload": "Uploaden",
  "editor.upload_title": "Beelden uploaden",
  "editor.upload_body": "JPEG, PNG, WebP of AVIF tot 25 MB, minimaal 800 × 500 pixels. Plattegronden en PDF-documenten mogen ook.",
  "editor.upload_submit": "{count, plural, =0 {Uploaden} one {# bestand uploaden} other {# bestanden uploaden}}",
  "editor.uploaded": "{count, plural, one {# beeld toegevoegd} other {# beelden toegevoegd}}",
  "editor.usable": "Bruikbaar",
  "editor.valid_range": "geldig {from} tot {until}",
  "editor.valid_until": "Geldig tot",
  "editor.views": "Uitzicht",
  "editor.websites": "Website",
  "editor.year_built": "Bouwjaar",
  "editor.delivery.generated": "Gegenereerd",
  "editor.delivery.sent": "Verstuurd",
  "editor.delivery.fetched": "Opgehaald",
  "editor.delivery.accepted": "Geaccepteerd",
  "editor.delivery.rejected": "Afgewezen",
  "editor.delivery.withdrawn": "Teruggetrokken",
  "editor.delivery.unknown": "Onbekend",
  "editor.field_group.identity": "Soort en referentie",
  "editor.field_group.location": "Locatie",
  "editor.field_group.facts": "Kenmerken",
  "editor.field_group.price": "Prijs",
  "editor.field_group.status": "Status",
  "editor.field_group.energy": "Energie",
  "editor.field_group.media": "Foto's",
  "editor.field_group.description": "Teksten",
  "editor.source_kind.manual": "Handmatig",
  "editor.source_kind.import": "Import",
  "editor.source_kind.owner": "Eigenaar",
  "editor.source_kind.inspection": "Bezichtiging ter plaatse",
  "editor.source_kind.seed": "Demodata",
  "editor.grant_state.active": "Geldig",
  "editor.grant_state.revoked": "Ingetrokken",
  "editor.grant_state.expired": "Verlopen",
  "editor.grant_state.future": "Nog niet geldig",
  "editor.loc_status.draft": "Concept",
  "editor.loc_status.proposed": "Voorgesteld",
  "editor.loc_status.in_review": "In review",
  "editor.loc_status.approved": "Goedgekeurd",
  "editor.loc_status.rejected": "Afgewezen",
  "editor.loc_status.stale": "Verouderd",
  "editor.loc_status.superseded": "Vervangen",
  "editor.lock_field.price": "Prijs",
  "editor.lock_field.status": "Status",
  "editor.lock_field.facts": "Kenmerken",
  "editor.lock_field.location": "Locatie",
  "editor.lock_field.description": "Teksten",
  "editor.lock_field.media": "Foto's",
  "editor.lock_field.identity": "Soort en referentie",
  "editor.media_kind.photo": "Foto",
  "editor.media_kind.floorplan": "Plattegrond",
  "editor.media_kind.document": "Document (PDF)",
  "editor.media_kind.video_link": "Video",
  "editor.media_kind.tour_link": "Virtuele rondleiding",
  "editor.source.manual": "Handmatig",
  "editor.source.bulk": "Bulkactie",
  "editor.source.import": "Import",
  "editor.source.restore": "Teruggezet",
  "editor.source.seed": "Demodata",
  "editor.source.create": "Aangemaakt",
  "editor.field.kind": "soort",
  "editor.field.bedrooms": "slaapkamers",
  "editor.field.bathrooms": "badkamers",
  "editor.field.builtM2": "bebouwd",
  "editor.field.usableM2": "bruikbaar",
  "editor.field.plotM2": "perceel",
  "editor.field.terraceM2": "terras",
  "editor.field.yearBuilt": "bouwjaar",
  "editor.field.floorLevel": "verdieping",
  "editor.field.orientation": "ligging",
  "editor.field.views": "uitzicht",
  "editor.field.features": "kenmerken",
  "editor.field.energyStatus": "energiecertificaat",
  "editor.field.energyRating": "energielabel",
  "editor.field.energyConsumption": "verbruik",
  "editor.field.touristLicense": "vergunning",
  "editor.field.locality": "plaats",
  "editor.field.municipality": "gemeente",
  "editor.field.areaId": "gebied",
  "editor.field.precision": "locatieweergave",
  "editor.field.amountMinor": "prijs",
  "editor.field.status": "status",
  "editor.field.priceOnRequest": "prijs op aanvraag",
  "editor.field.title": "titel",
  "editor.field.description": "omschrijving",
  "editor.field.metaDescription": "zoekmachinetekst",
  "editor.field.editorialStatus": "redactiestatus",
  "editor.field.reference": "referentie",
  "editor.field.offer.amountMinor": "prijs",
  "editor.field.offer.status": "status",
  "editor.issue.facts.no_bedrooms_for_kind": "Dit soort object heeft geen slaapkamers.",
  "editor.issue.facts.studio_has_no_bedrooms": "Een studio heeft geen aparte slaapkamers.",
  "editor.issue.facts.usable_exceeds_built": "Bruikbaar oppervlak is groter dan bebouwd oppervlak.",
  "editor.issue.facts.energy_rating_required": "Kies het energielabel bij een gecertificeerde woning.",
  "editor.issue.facts.year_built_future": "Bouwjaar ligt in de toekomst.",
  "editor.issue.ready.offer_missing": "Er is geen actieve verkoop of verhuur.",
  "editor.issue.ready.price_missing": "Vul een prijs in of kies prijs op aanvraag.",
  "editor.issue.ready.location_missing": "Vul de plaats of gemeente in.",
  "editor.issue.ready.area_missing": "Kies een gebied, dan verschijnt de woning ook op de gebiedspagina.",
  "editor.issue.ready.bedrooms_unknown": "Aantal slaapkamers onbekend.",
  "editor.issue.ready.bathrooms_unknown": "Aantal badkamers onbekend.",
  "editor.issue.ready.built_unknown": "Bebouwd oppervlak onbekend.",
  "editor.issue.ready.plot_unknown": "Vul de perceelgrootte in.",
  "editor.issue.ready.photos_few": "{count, plural, =0 {Nog geen foto's; minimaal 3 aanbevolen.} one {Pas # foto; minimaal 3 aanbevolen.} other {Pas # foto's; minimaal 3 aanbevolen.}}",
  "editor.issue.ready.cover_missing": "Kies een hoofdfoto.",
  "editor.issue.ready.website_right_missing": "Leg een geldig recht voor de website vast.",
  "editor.issue.ready.energy_unknown": "Energiecertificaat onbekend.",
  "editor.issue.ready.title_missing": "Schrijf een titel.",
  "editor.issue.ready.description_missing": "Schrijf een omschrijving.",
  "properties.view": "Weergave",
  "properties.view_list": "Lijst",
  "properties.view_grid": "Galerij",
  "properties.photos": "{count, plural, =0 {Geen foto's} one {# foto} other {# foto's}}",
  "properties.updated_title": "Gewijzigd {date}",
  "properties.ready_hint": "Klaar om te publiceren",
  "properties.per_month": " /mnd",
  "properties.per_week": " /week",
  "editor.changed_short": "Gewijzigd",
  "editor.ready_ok": "Klaar om te publiceren",
  "editor.dirty_tab": "Niet-opgeslagen wijzigingen",
  "editor.draft_restored": "Niet-opgeslagen wijzigingen teruggezet",
  "editor.uploads_label": "Uploads",
  "editor.upload_tile_queued": "Wacht",
  "editor.upload_tile_busy": "Uploaden",
  "editor.upload_tile_failed": "Niet geüpload",
  "editor.feature_group.outdoor": "Buiten",
  "editor.feature_group.parking": "Parkeren en opslag",
  "editor.feature_group.comfort": "Comfort en installaties",
  "editor.feature_group.setting": "Ligging",
  "editor.feature_group.other": "Overig",
  "editor.feature_group_count": "{group} · {count} gekozen"
}
